import React, { useEffect, useState } from 'react';
import { CTAButton } from '../components/CTAButton';
import { CheckItem } from '../components/CheckItem';
import { ChevronDown } from 'lucide-react';
export function LandingPage() {
  const [showStickyCTA, setShowStickyCTA] = useState(false);
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);
  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };
  const faqs = [{
    question: '1. ¿Esto es otra dieta más?',
    answer: 'No. Esta guía no es una dieta ni un plan restrictivo. Está diseñada para ayudarte a entender por qué no estás bajando de peso y qué está pasando realmente detrás de tus hábitos.'
  }, {
    question: '2. ¿Cuánto tiempo necesito para ver resultados?',
    answer: 'La guía está pensada para darte claridad en menos de 15 minutos. Desde el primer día vas a entender qué te está bloqueando y qué puedes empezar a cambiar.'
  }, {
    question: '3. ¿Esto funciona aunque ya haya probado de todo?',
    answer: 'Sí. De hecho, está pensada para personas que sienten que han probado todo y siguen en el mismo punto. Aquí no trabajamos solo lo que haces, sino por qué lo haces.'
  }, {
    question: '4. ¿Necesito hacer ejercicio o cambiar toda mi dieta?',
    answer: 'No. El objetivo no es cambiarlo todo de golpe, sino darte claridad y ayudarte a empezar con acciones simples y sostenibles desde hoy.'
  }, {
    question: '5. ¿Qué pasa si no tengo fuerza de voluntad?',
    answer: 'No necesitas más fuerza de voluntad. Esta guía te ayuda a entender los patrones que te llevan a fallar, para que no dependas solo de motivación.'
  }, {
    question: '6. ¿En qué formato recibiré el producto?',
    answer: 'Recibirás una guía digital clara y visual que puedes leer desde tu móvil, tablet o computadora en cualquier momento.'
  }, {
    question: '7. ¿Es complicado de seguir?',
    answer: 'No. Está diseñada para ser simple, directa y rápida. No es un curso largo ni tiene contenido innecesario.'
  }, {
    question: '8. ¿Y si no me funciona?',
    answer: 'Tienes una garantía de 7 días. Si no sientes más claridad sobre qué te está bloqueando, puedes pedir tu reembolso sin problema.'
  }, {
    question: '9. ¿Esto es para hombres o mujeres?',
    answer: 'Es para cualquier persona que esté frustrada por no poder bajar de peso, aunque en la comunicación usamos ejemplos más comunes en mujeres.'
  }, {
    question: '10. ¿Qué hace diferente a esta guía?',
    answer: 'Que no se centra solo en qué comer, sino en entender por qué no estás consiguiendo resultados. Ahí es donde realmente empieza el cambio.'
  }];
  // Show sticky CTA after scrolling past the hero section
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400) {
        setShowStickyCTA(true);
      } else {
        setShowStickyCTA(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToOffer = () => {
    const offerSection = document.getElementById('offer-section');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <div className="min-h-screen bg-slate-50 font-sans pb-20 selection:bg-orange-200 selection:text-orange-900" data-id="element-10">
      {/* Sticky Bottom CTA (Mobile & Desktop) */}
      <div className={`fixed bottom-0 left-0 right-0 p-3 bg-white/95 backdrop-blur-sm border-t border-slate-200 z-50 transition-transform duration-500 ${showStickyCTA ? 'translate-y-0' : 'translate-y-full'}`} data-id="element-11">
        <div className="max-w-4xl mx-auto flex justify-center" data-id="element-12">
          <CTAButton href="https://pay.hotmart.com/I105133397E?checkoutMode=10" fullWidth className="max-w-md shadow-orange-500/25 py-3 text-lg" data-id="element-13">
            👉 Quiero entenderlo ahora
          </CTAButton>
        </div>
      </div>

      <main className="max-w-3xl mx-auto px-4 md:px-6" data-id="element-14">
        {/* HERO SECTION */}
        <section className="pt-12 pb-8 md:pt-20 md:pb-12 text-center flex flex-col items-center" data-id="element-15">
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-slate-900 leading-tight tracking-tight mb-4 text-balance" data-id="element-16">
            ¿POR QUÉ NO PUEDES BAJAR DE PESO <br className="hidden md:block" data-id="element-17" />
            <span className="text-indigo-600" data-id="element-18">
              (aunque lo estés intentando TODO)?
            </span>
          </h1>

          <p className="text-lg md:text-xl text-slate-600 mb-6 text-balance leading-relaxed font-medium" data-id="element-19">
            Descubre en 15 minutos qué está bloqueando tu peso (y por qué todo
            lo que has probado hasta ahora no ha funcionado)
          </p>

          <CTAButton href="https://pay.hotmart.com/I105133397E?checkoutMode=10" className="mb-6 w-full sm:w-auto text-wrap py-3 text-lg" data-id="element-20">
            👉 ACCEDER AHORA POR $25.700
          </CTAButton>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-sm font-medium text-slate-500" data-id="element-21">
            <span className="flex items-center gap-2" data-id="element-22">
              <span className="text-emerald-500" data-id="element-23">✔</span> Sin dietas extremas
            </span>
            <span className="flex items-center gap-2" data-id="element-24">
              <span className="text-emerald-500" data-id="element-25">✔</span> Sin contar calorías
            </span>
            <span className="flex items-center gap-2" data-id="element-26">
              <span className="text-emerald-500" data-id="element-27">✔</span> Sin culpa
            </span>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-sm font-medium text-slate-500 mt-3" data-id="element-28">
            <span className="flex items-center gap-1.5" data-id="element-29">
              <span className="text-emerald-500" data-id="element-30">✔</span> Acceso inmediato
            </span>
            <span className="flex items-center gap-1.5" data-id="element-31">
              <span className="text-emerald-500" data-id="element-32">✔</span> Pago único
            </span>
            <span className="flex items-center gap-1.5" data-id="element-33">
              <span className="text-emerald-500" data-id="element-34">✔</span> Disponible hoy
            </span>
          </div>
        </section>

        {/* BLOQUE OFERTA RÁPIDA */}
        <section className="py-8 md:py-10 text-center" data-id="element-35">
          <div className="relative max-w-lg mx-auto" data-id="element-36">
            <div className="bg-white rounded-3xl p-6 md:p-8 shadow-xl border border-slate-100" data-id="element-37">
              <p className="text-xl md:text-2xl font-bold text-slate-700 mb-4" data-id="element-38">
                Accede ahora por solo:
              </p>
              <div className="mb-6" data-id="element-39">
                <div className="mb-2" data-id="element-40">
                  <span className="text-xl md:text-2xl text-slate-400 line-through font-semibold" data-id="element-41">
                    $80.000 COP
                  </span>
                </div>
                <span className="text-5xl md:text-6xl font-extrabold text-slate-900 tracking-tight" data-id="element-42">
                  $25.700{' '}
                  <span className="text-2xl md:text-3xl text-slate-500" data-id="element-43">
                    COP
                  </span>
                </span>
                <p className="text-base md:text-lg text-slate-500 mt-2 font-medium" data-id="element-44">
                  (menos de lo que cuesta una comida rápida)
                </p>
              </div>

              <CTAButton href="https://pay.hotmart.com/I105133397E?checkoutMode=10" className="w-full md:w-auto md:min-w-[280px] text-lg py-3" data-id="element-45">
                👉 Quiero empezar hoy
              </CTAButton>

              <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-6 text-xs md:text-sm font-medium text-slate-500 mt-5" data-id="element-46">
                <span className="flex items-center gap-1.5" data-id="element-47">
                  🔒 Pago seguro
                </span>
                <span className="flex items-center gap-1.5" data-id="element-48">
                  ⚡ Acceso instantáneo
                </span>
                <span className="flex items-center gap-1.5" data-id="element-49">
                  🛡 Garantía 7 días
                </span>
              </div>
            </div>
          </div>
        </section>

        {/* BLOQUE 2 — IDENTIFICACIÓN */}
        <section className="py-10 md:py-12 border-t border-slate-200" data-id="element-50">
          <p className="text-xl md:text-2xl font-bold text-slate-900 mb-6 text-center" data-id="element-51">
            ⚠️ Si esto te suena, sigue leyendo porque aquí está el problema:
          </p>

          <ul className="space-y-3 mb-8 bg-white p-5 md:p-8 rounded-2xl shadow-sm border border-slate-100" data-id="element-52">
            <CheckItem type="none" emoji="🔸" data-id="element-53">
              Comes poco… pero no bajas
            </CheckItem>
            <CheckItem type="none" emoji="🔸" data-id="element-54">
              Lo intentas otra vez… y vuelves a caer
            </CheckItem>
            <CheckItem type="none" emoji="🔸" data-id="element-55">
              No puedes controlar tus antojos
            </CheckItem>
            <CheckItem type="none" emoji="🔸" data-id="element-56">
              Sientes que tu metabolismo está roto
            </CheckItem>
            <CheckItem type="none" emoji="🔸" data-id="element-57">
              Estás cansada de empezar y fracasar
            </CheckItem>
          </ul>

          <div className="bg-indigo-50 border-l-4 border-indigo-500 p-5 md:p-6 rounded-r-xl" data-id="element-58">
            <p className="text-lg md:text-xl font-bold text-indigo-900 leading-relaxed" data-id="element-59">
              👉 No estás fallando. Pero sí estás repitiendo un patrón.
            </p>
          </div>
        </section>

        {/* BLOQUE 3 & 4 COMBINADO — DOLOR Y REVELACIÓN */}
        <section className="py-10 md:py-12 border-t border-slate-200" data-id="element-60">
          <h2 className="text-2xl md:text-3xl font-extrabold text-slate-900 mb-6 text-center" data-id="element-61">
            💣 Y lo peor no es el peso, es lo que pasa en tu cabeza:
          </h2>

          <div className="grid grid-cols-2 gap-4 mb-8" data-id="element-62">
            <div className="bg-rose-50 p-4 rounded-xl border border-rose-100 flex items-center gap-2" data-id="element-63">
              <span className="text-rose-500" data-id="element-64">▪️</span> Frustración
            </div>
            <div className="bg-rose-50 p-4 rounded-xl border border-rose-100 flex items-center gap-2" data-id="element-65">
              <span className="text-rose-500" data-id="element-66">▪️</span> Culpa
            </div>
            <div className="bg-rose-50 p-4 rounded-xl border border-rose-100 flex items-center gap-2" data-id="element-67">
              <span className="text-rose-500" data-id="element-68">▪️</span> Vergüenza
            </div>
            <div className="bg-rose-50 p-4 rounded-xl border border-rose-100 flex items-center gap-2" data-id="element-69">
              <span className="text-rose-500" data-id="element-70">▪️</span> Ansiedad
            </div>
          </div>

          <div className="text-center mb-8" data-id="element-71">
            <p className="text-lg md:text-xl text-slate-600 mb-2" data-id="element-72">
              Hasta que llega un punto en el que piensas:
            </p>
            <p className="text-xl md:text-2xl font-extrabold text-rose-900 italic" data-id="element-73">
              "Igual el problema soy yo…"
            </p>
          </div>

          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-slate-100" data-id="element-74">
            <h3 className="text-xl md:text-2xl font-extrabold text-slate-900 mb-4" data-id="element-75">
              🧠 No es tu cuerpo. Es el enfoque.
            </h3>
            <p className="text-lg text-slate-700 mb-4" data-id="element-76">
              Estás intentando resolver esto desde el lugar equivocado. El
              problema no es solo lo que comes, es:
            </p>
            <ul className="space-y-2 mb-4 pl-4" data-id="element-77">
              <CheckItem type="none" emoji="🔸" data-id="element-78">
                lo que sientes antes de comer
              </CheckItem>
              <CheckItem type="none" emoji="🔸" data-id="element-79">
                lo que haces sin darte cuenta
              </CheckItem>
              <CheckItem type="none" emoji="🔸" data-id="element-80">
                el patrón que repites cada día
              </CheckItem>
            </ul>
            <p className="text-lg font-bold text-indigo-600" data-id="element-81">
              👉 Nadie te ha enseñado a verlo así, por eso sientes que "has
              probado todo" y nada funciona.
            </p>
          </div>
        </section>

        {/* BLOQUE 5 — EXPLICACIÓN */}
        <section className="py-10 md:py-12 border-t border-slate-200" data-id="element-82">
          <h2 className="text-2xl md:text-3xl font-extrabold text-slate-900 mb-6 text-center" data-id="element-83">
            🔥 Esto no es teoría, es lo que realmente pasa:
          </h2>

          <div className="space-y-4" data-id="element-84">
            <div className="bg-white p-5 md:p-6 rounded-xl shadow-sm border border-slate-100 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4" data-id="element-85">
              <h3 className="text-lg md:text-xl font-bold text-slate-900 min-w-[200px]" data-id="element-86">
                👉 Hambre emocional
              </h3>
              <p className="text-base md:text-lg text-slate-600" data-id="element-87">
                Comes por ansiedad, estrés o aburrimiento
              </p>
            </div>

            <div className="bg-white p-5 md:p-6 rounded-xl shadow-sm border border-slate-100 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4" data-id="element-88">
              <h3 className="text-lg md:text-xl font-bold text-slate-900 min-w-[200px]" data-id="element-89">
                👉 Restricción → rebote
              </h3>
              <p className="text-base md:text-lg text-slate-600" data-id="element-90">
                Cuanto más te controlas… más pierdes el control
              </p>
            </div>

            <div className="bg-white p-5 md:p-6 rounded-xl shadow-sm border border-slate-100 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4" data-id="element-91">
              <h3 className="text-lg md:text-xl font-bold text-slate-900 min-w-[200px]" data-id="element-92">
                👉 Falta de claridad
              </h3>
              <p className="text-base md:text-lg text-slate-600" data-id="element-93">
                No sabes qué hacer en el momento clave
              </p>
            </div>
          </div>
        </section>

        {/* BLOQUE 6 — SOLUCIÓN */}
        <section className="py-10 md:py-12 border-t border-slate-200 text-center" data-id="element-94">
          <h2 className="text-xl md:text-2xl font-bold text-slate-600 mb-4" data-id="element-95">
            🚀 Por eso he creado esta guía
          </h2>

          <div className="bg-indigo-600 text-white p-6 md:p-8 rounded-2xl shadow-lg mb-8 transform -rotate-1 hover:rotate-0 transition-transform duration-300" data-id="element-96">
            <h3 className="text-2xl md:text-3xl lg:text-4xl font-extrabold leading-tight" data-id="element-97">
              "¿Por qué no puedo bajar de peso?"
            </h3>
          </div>

          <p className="text-lg md:text-xl text-slate-700 mb-8 font-medium text-balance" data-id="element-98">
            Una guía diseñada para darte claridad inmediata (no otro curso largo
            que no vas a terminar)
          </p>

          <div className="mb-8 flex justify-center" data-id="element-99">
            <img src="https://cdn.magicpatterns.com/uploads/694fjkvbZFFgpjGCEr82Ep/hf_20260326_160654_ff81ab1d-5972-4c39-9407-33fa9220c30c.png" alt="Vista previa de la guía en móvil" className="w-full max-w-xs md:max-w-sm rounded-xl shadow-xl" data-id="element-100" />
          </div>

          <div className="text-left bg-white p-5 md:p-8 rounded-2xl shadow-sm border border-slate-100 mx-auto max-w-xl" data-id="element-101">
            <p className="text-lg font-bold text-slate-900 mb-4" data-id="element-102">
              En solo 15 minutos vas a:
            </p>
            <ul className="space-y-3" data-id="element-103">
              <CheckItem data-id="element-104">Entender por qué no estás bajando de peso</CheckItem>
              <CheckItem data-id="element-105">Identificar tu bloqueo real</CheckItem>
              <CheckItem data-id="element-106">Saber exactamente qué hacer hoy</CheckItem>
            </ul>
          </div>
        </section>

        {/* BLOQUE 8 — CONTENIDO */}
        <section className="py-10 md:py-12 border-t border-slate-200" data-id="element-107">
          <h2 className="text-2xl md:text-3xl font-extrabold text-slate-900 mb-6 text-center" data-id="element-108">
            🧠 Lo que vas a descubrir dentro:
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 md:gap-4" data-id="element-109">
            <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-100 flex items-center gap-3" data-id="element-110">
              <span className="text-emerald-500 text-xl" data-id="element-111">✔</span>
              <span className="text-base md:text-lg font-bold text-slate-800" data-id="element-112">
                Guía visual rápida (sin relleno)
              </span>
            </div>
            <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-100 flex items-center gap-3" data-id="element-113">
              <span className="text-emerald-500 text-xl" data-id="element-114">✔</span>
              <span className="text-base md:text-lg font-bold text-slate-800" data-id="element-115">
                Sistema de 5 pasos
              </span>
            </div>
            <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-100 flex items-center gap-3" data-id="element-116">
              <span className="text-emerald-500 text-xl" data-id="element-117">✔</span>
              <span className="text-base md:text-lg font-bold text-slate-800" data-id="element-118">
                Plan de acción HOY y MAÑANA
              </span>
            </div>
            <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-100 flex items-center gap-3" data-id="element-119">
              <span className="text-emerald-500 text-xl" data-id="element-120">✔</span>
              <span className="text-base md:text-lg font-bold text-slate-800" data-id="element-121">
                Claridad inmediata
              </span>
            </div>
          </div>
        </section>

        {/* BLOQUE 9 — OBJECIONES */}
        <section className="py-10 md:py-12 border-t border-slate-200" data-id="element-122">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-123">
            <div className="bg-emerald-50 p-6 rounded-2xl border border-emerald-100" data-id="element-124">
              <h3 className="text-lg md:text-xl font-bold text-emerald-900 mb-4 flex items-start gap-2" data-id="element-125">
                <span className="mt-1" data-id="element-126">👉</span> Esto es exactamente lo que
                necesitas si:
              </h3>
              <ul className="space-y-3" data-id="element-127">
                <CheckItem type="check" data-id="element-128">Has probado todo</CheckItem>
                <CheckItem type="check" data-id="element-129">Estás cansada de fallar</CheckItem>
                <CheckItem type="check" data-id="element-130">Quieres algo simple y real</CheckItem>
              </ul>
            </div>

            <div className="bg-rose-50 p-6 rounded-2xl border border-rose-100" data-id="element-131">
              <h3 className="text-lg md:text-xl font-bold text-rose-900 mb-4 flex items-start gap-2" data-id="element-132">
                <span className="mt-1" data-id="element-133">👉</span> Esto NO es para ti si:
              </h3>
              <ul className="space-y-3" data-id="element-134">
                <CheckItem type="cross" data-id="element-135">Buscas otra dieta milagro</CheckItem>
                <CheckItem type="cross" data-id="element-136">
                  No estás dispuesto a cambiar tu enfoque
                </CheckItem>
              </ul>
            </div>
          </div>
        </section>

        {/* BLOQUE 10 — GARANTÍA */}
        <section className="py-8 md:py-10" data-id="element-137">
          <div className="bg-slate-900 text-white p-6 md:p-8 rounded-2xl shadow-xl text-center relative overflow-hidden" data-id="element-138">
            <div className="absolute top-0 right-0 -mt-2 -mr-2 text-6xl opacity-10" data-id="element-139">
              🛡
            </div>
            <div className="relative z-10" data-id="element-140">
              <div className="text-4xl mb-4" data-id="element-141">🛡</div>
              <p className="text-base md:text-lg leading-relaxed text-balance mb-4" data-id="element-142">
                Sabemos lo que es intentar una y otra vez sin resultados. Por
                eso tienes{' '}
                <span className="font-bold text-emerald-400" data-id="element-143">7 días</span> para
                probar esta guía con total tranquilidad.
              </p>
              <p className="text-base md:text-lg leading-relaxed text-balance mb-4" data-id="element-144">
                Si no te ayuda a entender qué te está bloqueando, te devolvemos
                el dinero.
              </p>
              <p className="text-lg md:text-xl font-bold leading-relaxed text-balance" data-id="element-145">
                👉 Sin riesgo. Sin culpa. Sin compromiso.
              </p>
            </div>
          </div>
        </section>

        {/* PREGUNTAS FRECUENTES */}
        <section className="py-10 md:py-12 border-t border-slate-200" data-id="element-146">
          <h2 className="text-2xl md:text-3xl font-extrabold text-slate-900 mb-8 text-center" data-id="element-147">
            Preguntas Frecuentes
          </h2>

          <div className="max-w-3xl mx-auto space-y-3" data-id="element-148">
            {faqs.map((faq, index) => <div key={index} className="bg-white rounded-xl shadow-sm border border-slate-100 overflow-hidden" data-id="element-149">
                <button onClick={() => toggleFAQ(index)} className="w-full p-5 flex items-center justify-between text-left hover:bg-slate-50 transition-colors" data-id="element-150">
                  <h3 className="text-lg md:text-xl font-bold text-slate-900 pr-4" data-id="element-151">
                    {faq.question}
                  </h3>
                  <ChevronDown className={`w-5 h-5 flex-shrink-0 text-slate-400 transition-transform duration-300 ${openFAQ === index ? 'rotate-180' : ''}`} data-id="element-152" />
                </button>
                <div className={`overflow-hidden transition-all duration-300 ${openFAQ === index ? 'max-h-96' : 'max-h-0'}`} data-id="element-153">
                  <p className="text-base text-slate-600 leading-relaxed px-5 pb-5" data-id="element-154">
                    {faq.answer}
                  </p>
                </div>
              </div>)}
          </div>
        </section>

        {/* BLOQUE FINAL */}
        <section className="py-10 md:py-12 text-center border-t border-slate-200" data-id="element-155">
          <p className="text-lg md:text-xl text-slate-600 mb-2" data-id="element-156">
            💥 Puedes seguir probando lo mismo…
          </p>
          <p className="text-xl md:text-2xl font-extrabold text-slate-900 mb-6" data-id="element-157">
            👉 o entender de una vez qué te está pasando.
          </p>

          <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-slate-200 mb-8 max-w-xl mx-auto" data-id="element-158">
            <p className="text-lg md:text-xl text-slate-600 mb-2" data-id="element-159">
              No necesitas otra dieta.
            </p>
            <p className="text-2xl md:text-3xl font-extrabold text-indigo-600 mb-4" data-id="element-160">
              👉 Necesitas claridad.
            </p>
            <p className="text-lg md:text-xl text-slate-800 font-medium" data-id="element-161">
              Y eso puede empezar hoy.
            </p>
          </div>

          <CTAButton href="https://pay.hotmart.com/I105133397E?checkoutMode=10" className="w-full md:w-auto md:min-w-[280px] text-lg py-3 shadow-orange-500/30" data-id="element-162">
            👉 Quiero entenderlo ahora
          </CTAButton>
        </section>
      </main>
    </div>;
}